$ = jQuery;

$(document).ready(function($) {
    const headerUserDropdown = $('header .header-mobile-dropdown');
    const menuToggle = $('header .hamburger');
    const close = $('header .header-mobile-dropdown .close');

    if($('header .header-wrapper').length > 0) {
        menuToggle.on('click', (e) => {
            e.preventDefault();
            jQuery(headerUserDropdown).toggleClass('active');
        });

        $(close).on('click', function (e) {
            $(headerUserDropdown).removeClass('active');
        });

        $('.language-dropdown .current-language').on('click', function(e){
            if ( $(e.target).closest('.language-dropdown').hasClass('open') ){
                $(e.target).closest('.language-dropdown').removeClass('open')
            } else {
                $(e.target).closest('.language-dropdown').addClass('open')
            }
        });
        $(document).on('click', function (e) {
            var dropdown = $(".language-dropdown");
            if (!$(e.target).closest(dropdown).length) {
                dropdown.removeClass('open');
            }
        });

        $('.language-dropdown .dropdown li').on('click', function(e){
            var newLang = $(e.target).html()
            $(e.target).closest('.language-dropdown').children('.current-language').html( newLang );
            console.log(newLang)
            $(e.target).closest('.language-dropdown').removeClass('open')
        });


        $('.bottom-head .sub-menu').each(function() {
            let currentItem = $( this ).find('.current-menu-item');
            if(currentItem.length > 0) {
                $( this ).css("display", "flex");
            }
        });

        var subMenu = $('.bottom-head .current-menu-item .sub-menu')
        if( subMenu.length > 0 ) {
            subMenu[0].style.display = 'flex';
        }

        $( ".bottom-head .menu-item-has-children" ).hover(
            function() {
                $( ".sub-menu" ).each(function() {
                    $( this ).css("display", "none");
                });
                $( this ).find('.sub-menu').css("display", "flex");
            }, function() {
                if( !$( this ).hasClass('current-menu-item') && !$(this).find('.sub-menu .current-menu-item').length ) {
                    $(this).find('.sub-menu').css("display", "none");
                }

                if( subMenu.length > 0 ) {
                    subMenu[0].style.display = 'flex';
                } else {
                    $('.bottom-head .sub-menu').each(function() {
                        let currentItem = $( this ).find('.current-menu-item');
                        if(currentItem.length > 0) {
                            $( this ).css("display", "flex");
                        }
                    });
                }
            }
        );
    }

    const flyModules = $('.fly-module-holder .fly-module:empty');
    if(flyModules.length) {
        flyModules.parent().remove()
    }

    var modalFade = $('.onload-modal-fade');
    var modalWindow = $('.onload-modal-window');
    var modalClose = $('.onload-modal-window .modal-close');
    var showHpAdPopup = getCookie('ad-hp-popup-v1');
    if(modalWindow.length && showHpAdPopup !== '1') {
        $(window).on('load', function () {
            var url = window.location.href;
            if (url.split("/").length > 0 && modalFade.length > 0) {
                setTimeout(
                    modalFade.fadeIn(),
                    5000);
                setTimeout(
                    modalWindow.fadeIn(),
                    5000);

                setCookie('ad-hp-popup-v1', '1', 1)
            }
        });


        if (modalFade.length > 0) {
            $(modalFade).on('click', function () {
                $(modalFade).fadeOut();
                $(modalWindow).fadeOut();
            });

            if(modalClose.length) {
                modalClose.on('click', function () {
                    modalFade.fadeOut();
                    modalWindow.fadeOut();
                })
            }
        }
    }

    function getCookie(key) {
        var name = key + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return null;
    }

    function setCookie(key, value, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = key + "=" + value + ";" + expires + ";path=/";
    }

});